import { useEffect } from "react";
import { useDispatch } from "react-redux";
import AttachableCheckbox from "./attachable-checkbox";
import AttachableRiderTable from "./attachable-rider-table";
import { useProposalTypeData } from "../../../../../../hooks/proposal/use-proposal-type-data";

export default function AttachableRiders() {

    const { 
        isSalaryRank,
        coverage,
        inputsByLevelRanking,
        inputsBySalaryRank,
        riders,
    } = useProposalTypeData();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({ type: "riders/resetSelectedRiders" });
    }, [coverage, dispatch]);

    const inputLength = isSalaryRank ? inputsBySalaryRank.length : inputsByLevelRanking.length

    return (
        <div className="w-full overflow-hidden rounded-lg border border-gray-200">
            <AttachableCheckbox />
            {/* {selectedRiders.length > 0 && <hr className="h-px border-0 bg-gray-200" />} */}
            {riders.length > 0 && (
                <AttachableRiderTable
                    isBySalaryRank={isSalaryRank}
                    inputLength={inputLength}
                />
            )}
        </div>
    );
}